import React from "react"
import { InputNumber, Typography } from "antd"
import PropTypes from "prop-types"
import styles from "./CustomTimeDropdown.module.css"
import { useTranslation } from "react-i18next"

const { Text } = Typography

export const CustomTimeDropdown = ({
  menu,
  customHour,
  customMinute,
  error,
  setCustomHour,
  setCustomMinute,
  handleCustomChange,
  label,
  disabled
}) => {
  const { t } = useTranslation()
  return (
    <>
      {menu}
      <div className={styles.dropdownContainer}>
        <div className={styles.label}>{label}</div>
        <div className={styles.inputRow}>
          <div className={styles.inputCol}>
            <InputNumber
              min={0}
              value={customHour}
              onChange={setCustomHour}
              placeholder="0 hr"
              className={error ? styles.inputNumberError : styles.inputNumber}
              disabled={disabled}
            />
          </div>
          <div className={styles.inputCol}>
            <InputNumber
              min={0}
              value={customMinute}
              onChange={setCustomMinute}
              placeholder="0 min"
              className={error ? styles.inputNumberError : styles.inputNumber}
              disabled={disabled}
            />
          </div>
        </div>
        {error && (
          <Text type="danger" className={styles.errorText}>
            {error}
          </Text>
        )}
        <div className={styles.applyButtonRow}>
          <button onClick={handleCustomChange} className={styles.applyButton}>
            {t("global.apply")}
          </button>
        </div>
      </div>
    </>
  )
}

CustomTimeDropdown.propTypes = {
  menu: PropTypes.node.isRequired,
  customHour: PropTypes.number.isRequired,
  customMinute: PropTypes.number.isRequired,
  error: PropTypes.string,
  setCustomHour: PropTypes.func.isRequired,
  setCustomMinute: PropTypes.func.isRequired,
  handleCustomChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}
